module.exports = __webpack_public_path__ + "media/images/search-icon-8f75c5c13b8773085e0afd33c7a81d67.svg";